import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Overlay from 'components/Overlay';
import Style from 'themes/AuthMVPDSearch.module.scss';

/**
 * MVPDSearch Component
 * @param {Object} theme
 * @param {Object} sharedTheme
 * @param {Node} children                       - any additional items: button, image, text, etc.
 * @param {Node} innerContainerChildren         - any additional items: button, image, text, etc.
 * @param {Boolean} rendered                    - should this item render?
 * @param {Function} onClose                    - click event for closing an overlay
 * @param {String} backgroundClass              - background class for overlay
 * @param {Object} innerContainerChildrenParams - parameters to be passed to innercontainerchildren
 * @param {Function} searchResults              - results to display based on the user input
 * @param {Function} searchInput                - the element used for search input
 * @param {Function} onResultClick              - result click event
 * @param {Function} onBackClick                - back click event
 * @param {Number} selectedChannel              - selected channel
 * @param {Function} onInputChange              - input change event
 * @returns {Component}                         - React Component
 */
class MVPDSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input: '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { rendered: prevRendered, tvProviderFullListViewed } = this.props;
    const { rendered: currentRendered } = nextProps;
    if (!prevRendered && currentRendered) {
      tvProviderFullListViewed();
    }
  }

  render() {
    const {
      backgroundUrl,
      children,
      innerContainerChildren,
      rendered,
      backgroundClass,
      innerContainerChildrenParams,
      searchResults,
      searchInput,
      onResultClick,
      onBackClick,
      selectedChannel,
      onInputChange,
      sharedTheme,
    } = this.props;
    const { input } = this.state;
    const onChange = onInputChange && _.isFunction(onInputChange) ? onInputChange.bind(this) : null;

    return (
      <Overlay
        backgroundClass={backgroundClass}
        backgroundUrl={backgroundUrl}
        sharedTheme={sharedTheme}
        theme={Style}
        rendered={rendered}
        innerContainerChildren={innerContainerChildren}
        innerContainerChildrenParams={{ ...innerContainerChildrenParams, onBack: onBackClick }}
      >
        {searchInput({ input, onInputChange: onChange, onBackClick })}
        {searchResults({ input, onProviderClick: onResultClick, selectedChannel })}
        {children}
      </Overlay>
    );
  }
}

MVPDSearch.defaultProps = {
  backgroundUrl: null,
  rendered: false,
  children: [],
  backgroundClass: '',
  innerContainerChildren: () => {},
  innerContainerChildrenParams: {},
  searchResults: () => {},
  searchInput: () => {},
  onResultClick: () => {},
  onBackClick: () => {},
  selectedChannel: null,
  onInputChange: () => {},
  tvProviderFullListViewed: () => {},
  sharedTheme: {},
};

MVPDSearch.propTypes = {
  backgroundUrl: PropTypes.string,
  rendered: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  backgroundClass: PropTypes.string,
  innerContainerChildrenParams: PropTypes.shape({}),
  innerContainerChildren: PropTypes.func,
  searchResults: PropTypes.func,
  searchInput: PropTypes.func,
  onResultClick: PropTypes.func,
  onBackClick: PropTypes.func,
  selectedChannel: PropTypes.number,
  onInputChange: PropTypes.func,
  tvProviderFullListViewed: PropTypes.func,
  sharedTheme: PropTypes.shape({}),
};

export default MVPDSearch;
